// extracted by mini-css-extract-plugin
export default {"container":"bM-z","topReviewHeading":"cM-z","criticalReview":"dM-z","favorableReview":"eM-z","vsSeparator":"fM-z"};